// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2y_Cw","ranges":"BmiRanges_ranges__2Ba_C"};